import React, { useState } from "react";
import {
  Button,
  Container,
  Typography,
  Grid,
  Box,
  Avatar,
  Chip,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
} from "@mui/material";
import FileList from "../filefolder/Files";
import Navbar from "./Navbar"; // Import the Navbar component
import Sidenav from "./Sidenav"; // Import the Sidenav component
import DeleteIcon from "@mui/icons-material/Delete"; // Import the Delete icon
import { Paper } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import RefreshIcon from "@mui/icons-material/Refresh";
import SortIcon from "@mui/icons-material/Sort";
import ListIcon from "@mui/icons-material/List";
import InfoIcon from "@mui/icons-material/Info";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import CustomSnackbar from "../shared/snackbar";
import WordIcon from "../../assets/images/word.png"; // Import your Word icon PNG
import excelIcon from "../../assets/images/excel.png"; // Import your Excel icon PNG
import PdfIcon from "../../assets/images/pdf3.png";
import FolderIcon from "../../assets/images/folder3.png";
import pngIcon from "../../assets/images/png2.png";
import zipIcon from "../../assets/images/zip1.png";
import DefaultIcon from "../../assets/images/default.png";
import mp4Icon from "../../assets/images/mp4.png";
import TextIcon from "../../assets/images/default.png";
import jpgIcon from "../../assets/images/jpg.png";
import jsonIcon from "../../assets/images/json.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import RestoreIcon from "@mui/icons-material/Restore";
import "../../assets/css/styles.css";
import { data } from "flickity";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const imageStyle = {
  maxWidth: "32px", // Set a maximum width for the image
  maxHeight: "32px", // Set a maximum height for the image
};
const fileIconMapping = {
  pdf: <img src={PdfIcon} alt="Word" style={imageStyle} />, // Example: PDF files
  doc: <img src={WordIcon} alt="Word" style={imageStyle} />, // Example: Word documents
  docx: <img src={WordIcon} alt="Word" style={imageStyle} />, // Example: Word documents
  jpg: <img src={jpgIcon} alt="Word" style={imageStyle} />, // Example: JPEG images
  jpeg: <img src={pngIcon} alt="Word" style={imageStyle} />, // Example: JPEG images
  png: <img src={pngIcon} alt="Word" style={imageStyle} />, // Example: PNG images
  mp4: <img src={mp4Icon} alt="Word" style={imageStyle} />, // Example: MP4 videos
  txt: <img src={TextIcon} alt="Word" style={imageStyle} />,
  xlsx: <img src={excelIcon} alt="Word" style={imageStyle} />,
  zip: <img src={zipIcon} alt="Word" style={imageStyle} />,
  folders: <img src={FolderIcon} alt="Word" style={imageStyle} />,
  json: <img src={jsonIcon} alt="Word" style={imageStyle} />,
  // Add more file extensions and icons as needed
  default: <img src={FolderIcon} alt="Word" style={imageStyle} />,
};
function RecycleBin() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const RECYCLE_BIN_LIST = `${SERVER_URI}/recycleBinList`;
  const EMPTY_RECYCLE_BIN = `${SERVER_URI}/deleteRecyclebinContents`;
  const RESTORE_BIN = `${SERVER_URI}/restore-multiple-recycle-bin`;
  const DELETE_FILE_URL = `${SERVER_URI}/permanent-file-delete`;

  const [selectedFilter, setSelectedFilter] = React.useState("all");

  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);

  // For list views menu
  const [viewAnchorEl, setViewAnchorEl] = useState(null);
  const [viewMenuOpen, setViewMenuOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("list"); // Default view

  const [message, setMessage] = React.useState("");
  const [variant, setMessageVariant] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  const handleSortMenuOpen = (event) => {
    setSortAnchorEl(event.currentTarget);
    setSortMenuOpen(true);
  };

  const handleSortMenuClose = () => {
    setSortAnchorEl(null);
    setSortMenuOpen(false);
  };

  const handleViewMenuOpen = (event) => {
    setViewAnchorEl(event.currentTarget);
    setViewMenuOpen(true);
  };

  const handleViewMenuClose = () => {
    setViewAnchorEl(null);
    setViewMenuOpen(false);
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
    handleViewMenuClose();
  };

  const handleFileInfo = () => {};

  const [recycleBinData, setRecycleBinData] = useState([]); // Store recycle bin data

  // Fetch the recycle bin list from the server when the component mounts
  const fetchRecycleBinList = async () => {
    try {
      let token = localStorage.getItem("accessToken");
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(RECYCLE_BIN_LIST, config);

      if (response.data && response.data.files) {
        // Use response instead of responseData
        const recycleBinData = response.data.files.map((file) => {
          console.log("API Data:", file);

          // Formatting the modifiedDate
          const modifiedDate = new Date(file.Date);
          const formattedDate = `${modifiedDate.getDate()}-${
            monthNames[modifiedDate.getMonth()]
          }-${modifiedDate.getFullYear()}`;

          return {
            filename: file.fileName,
            modifiedDate: formattedDate,
            size: file.size,
            url: file.url,
          };
        });

        setRecycleBinData(recycleBinData);
      } else {
        console.error("Failed to fetch data from the API");
      }
    } catch (error) {
      console.error("Error while fetching recycle bin data:", error);
    }
  };
  React.useEffect(() => {
    fetchRecycleBinList();
  }, []);

  // Function to empty the recycle bin
  const emptyRecycleBin = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.delete(EMPTY_RECYCLE_BIN, config);

      if (response.status === 200) {
        // Successfully emptied the recycle bin
        setRecycleBinData([]);
        setMessage("Recycle bin Contents deleted successfully");
        setMessageVariant("success");
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        setSnackbarOpen(true);
      } else {
        console.error("Failed to empty the recycle bin");
        setMessage("Failed to empty the recycle bin");
        setMessageVariant("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error while emptying the recycle bin:", error);
      setMessage("Error while emptying the recycle bin");
      setMessageVariant("error");
      setSnackbarOpen(true);
    }
  };
  const getFileExtension = (filename) => {
    // Check if filename is defined and not null
    if (filename) {
      const parts = filename.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "default";
      return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
    }
    // Return a default extension or handle the case where filename is undefined or null
    return "unknown";
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const [hoveredRow, setHoveredRow] = React.useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const handleRowMouseEnter = (fileId) => {
    setHoveredRow(fileId);
  };

  const handleRowMouseLeave = () => {
    setHoveredRow(null);
  };

  const handleContextMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleContextMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleRestore = async (fileName) => {
    try {
      const token = localStorage.getItem("accessToken");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await axios.post(
        RESTORE_BIN,
        { files: fileName },
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setMessage(response.data.message);
        setMessageVariant("success");
        setSnackbarOpen(true);
        fetchRecycleBinList();
        setTimeout(() => {
          setSnackbarOpen(false);
        }, 1000);
        setSelectedFiles([]);

        setRecycleBinData((prevData) =>
          prevData.filter((file) => file.filename !== fileName)
        );
      } else {
        console.error(`Failed to restore item: ${response.data.message}`);
        setMessage(`Failed to restore item: ${response.data.message}`);
        setMessageVariant("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error while restoring item", error.response);
      setMessage(error.response.data.message);
      setMessageVariant("error");
      setSnackbarOpen(true);
    }
  };

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [rows, setRows] = useState([]);

  // Add this function in your component function
  const handleSelectAllClick = (event) => {
    const checked = event.target.checked;

    if (checked) {
      // Select all files
      setSelectedFiles(recycleBinData.map((file) => file.filename));
    } else {
      // Deselect all files
      setSelectedFiles([]);
    }

    setIsSelectAll(checked);
  };

  // Add this function in your component function
  const handleRowSelect = (event, fileName) => {
    const checked = event.target.checked;

    if (checked) {
      // Add the filename to the selectedFiles array
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      // Remove the filename from the selectedFiles array
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const response = await axios.delete(DELETE_FILE_URL, {
        headers: config.headers,
        data: { files: selectedFiles }, // Sending selected files to delete
      });

      if (response.status === 200) {
        console.log(response);
        // Update UI or perform any necessary actions upon successful deletion
        console.log("Files deleted successfully");
        setSelectedFiles([]); // Clear selected files after deletion
        setMessage(response.data.message);
        setMessageVariant("success");
        setSnackbarOpen(true);
        fetchRecycleBinList();
        setTimeout(() => {
          // fetchRecycleBinList();
          setSnackbarOpen(false);
        }, 3000);
        // You might want to refresh the file list here or update state accordingly
      } else {
        console.error("Failed to delete files");
        setMessage(response.data.message);
        setMessageVariant("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error while emptying the recycle bin:", error);
      setMessage("Error while deleting ");
      setMessageVariant("error");
      setTimeout(() => {
        fetchRecycleBinList();
        setSnackbarOpen(false);
      }, 3000);
      setSnackbarOpen(true);
    }
  };

  const isMenuOpen = Boolean(menuAnchor);

  const handleMenuClick = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <Box sx={{ margin: "0px", backgroundColor: "red" }}>
      <div className="bgcolor">
        <Navbar /> {/* Include the Navbar component here */}
        <Box height={70} />
        <Box sx={{ display: "flex", padding: "1%" }}>
          <Sidenav />
          <Box component="main" sx={{ flexGrow: 1, p: 3, width: "80%",position:"relative",right:"1%" }}>
            {/* <IconButton onClick={handleGoBack} color="primary" >
                  <ArrowBackIcon />
                <Typography><strong>Back</strong></Typography>
                </IconButton> */}

            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              direction={{ xs: "column", sm: "row" }}
            >
              {/* Empty Recycle Bin section */}
              <Grid
                item
                xs={6}
                sm={6}
                container
                justifyContent="flex-start"
                sx={{
                  display: { xs: "none", sm: "block" },
                }}
              >
                <IconButton
                  onClick={emptyRecycleBin}
                  color="primary"
                  sx={{
                    position: "relative",
                    top: { xs: "20px", sm: "10px" },
                    left: { xs: "10%", sm: "0%", md: "9%" },
                  }}
                >
                  <DeleteIcon />
                  <Typography>Empty Recycle Bin</Typography>
                </IconButton>
              </Grid>

              {/* Refresh, Sort, and Info icons section */}
              <Grid
                item
                xs={6}
                sm={6}
                container
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid
                    item
                    sx={{
                      position: "relative",
                      top: { xs: "20px", sm: "34px" },
                      left: {
                        xs: "10%",
                        sm: "24%",
                        md: "30%",
                        lg: "47%",
                        xl: "46%",
                      },
                    }}
                  >
                    <IconButton
                      onClick={handleRefresh}
                      color="primary"
                      sx={{
                        display: { xs: "none", sm: "none" }, // Hide on mobile, show on tablet and larger
                      }}
                    >
                      <RefreshIcon />
                      <Typography>Refresh</Typography>
                    </IconButton>

                    <Tooltip title="Sort">
                      <IconButton
                        onClick={handleSortMenuOpen}
                        color="primary"
                        sx={{
                          display: { xs: "none", sm: "none" }, // Hide on mobile, show on tablet and larger
                        }}
                      >
                        <SortIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={sortAnchorEl}
                      open={sortMenuOpen}
                      onClose={handleSortMenuClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuItem onClick={handleSortMenuClose}>
                        File Type
                      </MenuItem>
                      <MenuItem onClick={handleSortMenuClose}>Name</MenuItem>
                      <MenuItem onClick={handleSortMenuClose}>
                        Modified
                      </MenuItem>
                      <MenuItem onClick={handleSortMenuClose}>
                        File Size
                      </MenuItem>
                    </Menu>

                    <Tooltip title="Info">
                      <IconButton
                        onClick={handleFileInfo}
                        color="primary"
                        sx={{
                          display: { xs: "none", sm: "none" }, // Hide on mobile, show on tablet and larger
                        }}
                      >
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center " }}
              >
                <Paper
                  sx={{
                    overflow: "auto",
                    maxHeight: "100vh",
                    borderRadius: "20px",
                    width: { xs: "100%", sm: "100%", md: "90%" },
                    marginTop: {
                      xs: "0px",
                      sm: "30px",
                      md: "30px",
                      lg: "30px",
                    },
                    position: "relative",
                    left: "0%",
                  }}
                >
                  {" "}
                  {/* Add borderRadius here */}
                  <TableContainer
                    sx={{
                      maxHeight: 440,
                      borderRadius: "20px",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left" style={{ minWidth: "100px" }}>
                            <Checkbox
                              checked={isSelectAll}
                              onChange={handleSelectAllClick}
                            />
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ minWidth: "100px" }}
                            sx={{
                              display: { xs: "none", sm: "table-cell" },
                            }}
                          >
                            <strong>Last Modified</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{ minWidth: "100px" }}
                            sx={{
                              display: { xs: "none", sm: "table-cell" },
                            }}
                          >
                            <strong>File Size</strong>
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              minWidth: "100px",
                              display: { xs: "none", md: "flex" },
                              justifyContent: "space-evenly",
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={() => handleRestore(selectedFiles)}
                              startIcon={<RestoreIcon />}
                              disabled={selectedFiles.length === 0}
                            >
                              Restore
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={handleDelete}
                              disabled={selectedFiles.length === 0}
                            >
                              <DeleteIcon /> {/* Icon for Delete Selected */}
                            </Button>
                          </TableCell>
                          {/* <TableCell
                            sx={{
                              display: { xs: "none", md: "table-cell" },
                            }}
                          >
                            
                          </TableCell> */}
                          <TableCell
                            sx={{
                              display: { xs: "table-cell", md: "none" },
                            }}
                          >
                            <IconButton onClick={handleMenuClick}>
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              anchorEl={menuAnchor}
                              open={isMenuOpen}
                              onClose={handleMenuClose}
                            >
                              <MenuItem
                                onClick={() => {
                                  handleRestore(selectedFiles);
                                  handleMenuClose();
                                }}
                              >
                                Restore
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDelete();
                                  handleMenuClose();
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </TableCell>
                          <TableCell>
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              container
                              justifyContent="flex-start"
                              sx={{
                                display: { xs: "block", sm: "none" },
                              }}
                            >
                              <IconButton
                                onClick={emptyRecycleBin}
                                color="primary"
                                sx={{
                                  position: "relative",
                                  top: { xs: "0px", sm: "34px" },
                                  left: { xs: "0%", sm: "10%" },
                                }}
                              >
                                <DeleteIcon />
                                <Typography
                                  sx={{
                                    display: { xs: "none", sm: "block" },
                                  }}
                                >
                                  Empty Recycle Bin
                                </Typography>
                              </IconButton>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {recycleBinData
                          .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                          .map((file) => {
                            return (
                              <TableRow
                                key={file.id}
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                onMouseEnter={() =>
                                  handleRowMouseEnter(file.filename)
                                }
                                onMouseLeave={handleRowMouseLeave}
                              >
                                <TableCell>
                                  <Checkbox
                                    checked={selectedFiles.includes(
                                      file.filename
                                    )}
                                    onChange={(event) =>
                                      handleRowSelect(event, file.filename)
                                    }
                                  />
                                  {fileIconMapping[
                                    getFileExtension(file.filename)
                                  ] || <InsertDriveFileIcon />}
                                  {file.filename}
                                  {/* {hoveredRow === file.filename && (
              <div style={{ position: "relative", bottom: "20px", marginLeft: "80px" }}>
                <IconButton
                   style={{
                    position: 'absolute',
                    top: '2px',
                    left: '300px',
                    transform: 'translate(-50%, -50%)',
                  }}
                  onClick={handleContextMenuOpen}
                >
                  <MoreHorizOutlinedIcon />
                </IconButton>
                <Menu
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={handleContextMenuClose}
      style={{
        // Add responsive styles for the menu
        // You can customize these styles based on your requirements
        position: 'absolute',
       // Adjust this value based on your layout
       top:'228px',
        left: '520px', // Center the menu horizontally
        transform: 'translate(-50%, -50%)',
      }}
    >
      <MenuItem  onClick={()=>handleRestore(file.filename)} >Restore</MenuItem>
     
    </Menu>
              </div>
            )}
               */}
                                </TableCell>
                                <TableCell>{file.modifiedDate}</TableCell>
                                <TableCell>{file.size}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    className="tablepagenition"
                    rowsPerPageOptions={[5, 10, 100]}
                    component="div"
                    count={recycleBinData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Stack spacing={2}></Stack>
            </Grid>

            {/* Add more content for the "Favorites" screen */}
          </Box>
        </Box>
        <CustomSnackbar
          message={message}
          variant={variant}
          open={snackbaropen}
        />
      </div>
    </Box>
  );
}

export default RecycleBin;
